import { Model } from 'app/model/backendmodel';
import { CommonDataServiceLinkedService } from './../../linkedservice/common-data-service.linkedservice';
import { AdapterRegistry } from '../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { GlobalVariables } from 'app/services/globals';
import { dynamicsLSProperties, dynamicsPropertiesToModelAsync, dynamicsPropertiesToResourceAsync } from './dynamics-linkedservice.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(CommonDataServiceLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: dynamicsLSProperties
    }
})
export class CommonDataServiceLinkedServiceAdapter extends LinkedServiceAdapter<CommonDataServiceLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => CommonDataServiceLinkedService {
        return CommonDataServiceLinkedService;
    }

    protected model(): IModel {
        return CommonDataServiceLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: CommonDataServiceLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.CommonDataServiceLinkedService;
        properties.type = Metamodel.modelFor(CommonDataServiceLinkedService).name;
        return dynamicsPropertiesToResourceAsync(linkedService, properties, linkedServiceResource, GlobalVariables.enableConnectorUserAuthCred, this.context, this.valueToResource.bind(this));
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: CommonDataServiceLinkedService): Promise<CommonDataServiceLinkedService> {
        const properties = linkedServiceResource.properties as Model.CommonDataServiceLinkedService;
        const typeProperties: Model.CommonDataServiceLinkedServiceTypeProperties = properties.typeProperties;
        return dynamicsPropertiesToModelAsync(typeProperties, linkedService, this.context);
    }
}
